import React from 'react';

interface TypingIndicatorProps {
  users: string[];
  maxDisplay?: number;
}

const TypingIndicator: React.FC<TypingIndicatorProps> = ({ users, maxDisplay = 2 }) => {
  if (users.length === 0) return null;

  const displayedUsers = users.slice(0, maxDisplay);
  const hiddenCount = Math.max(0, users.length - maxDisplay);

  return (
    <div className="flex items-center gap-2 p-3 text-sm text-light-subtle dark:text-dark-subtle">
      <div className="flex items-center gap-1.5">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="w-2 h-2 rounded-full bg-light-subtle dark:bg-dark-subtle"
            style={{
              animation: `pulse 1.4s infinite`,
              animationDelay: `${i * 0.2}s`,
            }}
          />
        ))}
      </div>
      <span>
        {displayedUsers.length === 1
          ? `${displayedUsers[0]} is typing`
          : `${displayedUsers.join(', ')} are typing`}
        {hiddenCount > 0 && ` +${hiddenCount} more`}
      </span>

      <style>{`
        @keyframes pulse {
          0%, 60%, 100% {
            opacity: 0.3;
          }
          30% {
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default TypingIndicator;
